<template>
  <div class="overall-budget-container">
    <el-row :gutter="20" class="dashboard-container" v-loading="loading">
      <el-col :span="8" class="dashboard-item" v-for="(item, index) in dashboardItem" :key="index">
        <dashboard-module title-slot :has-operation="false">
          <template #title>
            <span class="title-year">{{ item.wageYear }}</span>
            <span class="title-text">年{{ item.dataType }}数据（万元）</span>
          </template>
          <div class="dashboard-attr flex jbetween acenter">
            <div class="attr">
              <p class="attr-value">{{ item.allCost }}</p>
              <p class="attr-name">人工成本总额</p>
              <div class="compare-list">
              <span class="compare" :class="`compare ${symbolClass(item.allCostOnYear).symbolClass}`" v-if="index != dashboardItem.length - 1">
                <i :class="`icon-compare el-icon-caret-${symbolClass(item.allCostOnYear).symbolDir}`"></i>
                <i class="compare-value">{{ item.allCostOnYear | dashboardPercent }}</i>
              </span>
              </div>
            </div>
            <div class="attr">
              <p class="attr-value">{{ item.salaryCost }}</p>
              <p class="attr-name">工资总额</p>
              <div class="compare-list">
              <span class="compare" :class="`compare ${symbolClass(item.salaryCostOnYear).symbolClass}`" v-if="index != dashboardItem.length - 1">
                <i :class="`icon-compare el-icon-caret-${symbolClass(item.salaryCostOnYear).symbolDir}`"></i>
                <i class="compare-value">{{ item.salaryCostOnYear | dashboardPercent }}</i>
              </span>
              </div>
            </div>
            <div class="attr">
              <p class="attr-value">{{ item.avgSalaryCost }}</p>
              <p class="attr-name">人均工资水平</p>
              <div class="compare-list">
              <span class="compare" :class="`compare ${symbolClass(item.avgSalaryCostOnYear).symbolClass}`" v-if="index != dashboardItem.length - 1">
                <i :class="`icon-compare el-icon-caret-${symbolClass(item.avgSalaryCostOnYear).symbolDir}`"></i>
                <i class="compare-value">{{ item.avgSalaryCostOnYear | dashboardPercent }}</i>
              </span>
              </div>
            </div>
          </div>
        </dashboard-module>
      </el-col>
    </el-row>
    <div class="view-operation flex jcenter acenter" title="查看详情" @click="handleView">
      <i class="el-icon-s-grid" style="font-size: 32px; color: #606266;"></i>
    </div>
    <el-dialog
      class="modal-v2 has-padding"
      width="800px"
      v-dialogDrag
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="总体预算"
      :visible.sync="visible"
      append-to-body
    >
      <div class="w100 flex center mt20 mb20" style="max-height: calc(100vh - 200px); overflow-y: auto">
        <vxe-grid
          size="mini"
          class="ciic-vxe-grid"
          :data="getTableData"
          :tree-config="{ children: 'children', expandAll: true }"
          :columns="getColumns"
          :row-config="{ keyField: 'id' }"
          border
          stripe
          header-cell-class-name="air-table-header-cell"
          row-class-name="air-table-row"
          cell-class-name="air-table-cell"
        >
        </vxe-grid>
      </div>
      
      <div slot="footer" class="w100 flex jend acenter">
        <el-button plain class="button-v2" @click="visible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import DashboardModule from './DashboardModule'
  import { validatenull } from "@/util/validate";
  import { getAllBudgetByYear } from '@/api/v2/stats/data-center/dashboard'

  export default {
    name: "OverallBudget",
    components: {
      DashboardModule
    },
    data() {
      return {
        loading: false,
        visible: false,
        dashboardItem: []
      }
    },
    created() {
      this.getData()
    },
    methods: {
      getData() {
        this.loading = true
        const params = {
          year: this.$day().format('YYYY')
        }
        getAllBudgetByYear(params)
        .then(res => {
          this.dashboardItem = res.data.data
          this.loading = false
        })
        .catch(() => { this.loading = false })
      },
      symbolClass(val) {
        let symbolClass = '';
        let symbolDir = '';
        if (validatenull(val) || val == 0) {
          symbolClass = 'common';
          symbolDir = '';
        } else if (val > 0) {
          symbolClass = 'increase';
          symbolDir = 'top';
        } else {
          symbolClass = 'reduce';
          symbolDir = 'bottom';
        }
        return {
          symbolClass,
          symbolDir
        };
      },
      handleView() {
        this.visible = true
      }
    },
    computed: {
      getColumns(){
        const firstColumn = {
          field: 'columnName', title: '单位：中粮信托', minWidth: 200, treeNode: true
        }
        const dynamicColumns = this.dashboardItem.map(item => {
          return {
            title: `${ item.wageYear }年${ item.dataType }`,
            field: `year${ item.wageYear }`,
            minWidth: 150
          }
        })
        return [firstColumn, ...dynamicColumns]
      },
      getTableData() {
        let tableData = [
          { columnName: '人工成本总额（万元）' },
          { columnName: '工资总额（万元）' },
          { columnName: '职工平均人数' },
          { columnName: '人均人工成本（万元）' },
          { columnName: '人均工资水平（万元）' }
        ]
        tableData[1].children = [
          { columnName: '其中: 固薪及补贴' },
          { columnName: '其中: 绩效奖金' },
          { columnName: '其中: 协同奖金' }
        ]
        this.dashboardItem.forEach(item => {
          tableData[0][`year${ item.wageYear }`] = item.allCost
          tableData[1][`year${ item.wageYear }`] = item.salaryCost
          tableData[2][`year${ item.wageYear }`] = item.avgNumEmployee
          tableData[3][`year${ item.wageYear }`] = item.avgAllCost
          tableData[4][`year${ item.wageYear }`] = item.avgSalaryCost
  
          tableData[1].children[0][`year${ item.wageYear }`] = item.fixedSalary
          tableData[1].children[1][`year${ item.wageYear }`] = item.performanceBonus
          tableData[1].children[2][`year${ item.wageYear }`] = item.collaborativeBonus
        })
        return tableData
      }
    }
  }
</script>

<style lang="scss" scoped>
  .overall-budget-container {
    display: flex;
    justify-content: space-between;
    .dashboard-container {
      width: calc(100% - 66px);
    }
    .view-operation {
      width: 66px;
      background-color: #fff;
      cursor: pointer;
      -webkit-border-radius: 6px;
      -moz-border-radius: 6px;
      border-radius: 6px;
    }
  }
  .dashboard-item {
    .dashboard-module {
      background-position: right bottom;
      background-repeat: no-repeat;
      -webkit-background-size: auto 65%;
      background-size: auto 65%;
    }
    &:nth-of-type(2) .dashboard-module{
      background-image: url('~@/assets/img/dashboard/icon-1.png');
    }
    &:nth-of-type(3) .dashboard-module{
      background-image: url('~@/assets/img/dashboard/icon-2.png');
    }
    &:nth-of-type(4) .dashboard-module{
      background-image: url('~@/assets/img/dashboard/icon-3.png');
    }
  }
  .dashboard-attr {
    width: 100%;
    .attr {
      width: 33.3%;
      .attr-name {
        color: #666;
        margin-bottom: 6px;
      }
      .attr-value {
        font-size: 26px;
        color: #000;
      }
      .compare-list {
        height: 24px;
      }
      .compare {
        color: #8f8f93;
        font-size: 12px;
        display: flex;
        align-items: center;
        height: 24px;
        margin-right: 12px;
        .icon-compare {
          margin-right: 2px;
          font-size: 1.3em;
        }
        .compare-value {
          font-style: normal;
          margin-right: 4px;
        }
        &.reduce {
          .icon-compare, .compare-value {
            color: #34e0cc;
          }
        }
        &.increase {
          .icon-compare, .compare-value {
            color: #fc4444;
          }
        }
        &.common {
          color: #999;
          .compared-arrow {
            background-color: rgba(52, 224, 204, 0.2);
          }
        }
      }
    }
  }
  @import "~@/styles/media.scss";
</style>
